import { IonIcon } from '@ionic/react'
import { CardActions, CardContent } from '@mui/material'
import React, { FC, useContext } from 'react'
import { checkmarkCircleOutline } from 'ionicons/icons'
import { logEvent } from '../../../analytics/utils/firebaseUtils'
import Button from '../../../components/actions/Button'
import { ModalContext } from '../../../contexts/ModalContext'
import ModalWrapper from '../../../wrappers/modalWrapper/ModalWrapper'

const ContactConfirmationModal: FC = () => {
	const { clearModals } = useContext(ModalContext)

	const onClose = () => {
		logEvent('click-generic-cancel')
		clearModals()
	}

	return (
		<ModalWrapper appBarOptions={{ closeFunction: onClose }}>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignContent: 'center',
					alignItems: 'center',
					height: '100%',
					width: '100%',
					margin: 'auto',
				}}
			>
				<IonIcon
					className='text-[15rem] text-brand-primary-100-light dark:text-brand-primary-100-dark'
					icon={checkmarkCircleOutline}
				/>
				<CardContent className='text-center text-text-dark dark:text-white'>
					Ilmoituksesi on vastaanotettu ja siirtyy käsiteltäväksi. Mikäli tarvitsemme lisätietoja,
					otamme sinuun yhteyttä sähköpostitse.
				</CardContent>
				<CardActions className='justify-center'>
					<Button className='w-40' size='large' onClick={onClose}>
						Sulje
					</Button>
				</CardActions>
			</div>
		</ModalWrapper>
	)
}

export default ContactConfirmationModal
